import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api_authSession } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Synchronous guard prevents StrictMode double-fire
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(m[1]);
    (async () => {
      try {
        const data = await api_authSession(sessionId);
        // Clear the fragment so it isn't reprocessed if user refreshes
        window.history.replaceState({}, document.title, window.location.pathname);
        setUser(data);
        navigate(data.has_profile ? "/home" : "/onboarding", { replace: true });
      } catch (e) {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center text-slate-500" data-testid="auth-callback-loading">
      Signing you in…
    </div>
  );
}
